<template>
	<div>
		<header ref="header" :class="'header-' + variant + ' ishide-' + isHide">
			<div class="header-container">
				<div class="logo">
					<a @click="goToPage('/index')" data-cursor><img src="@/assets/logo.png" alt="logo" /></a>
					<div class="logo-title">
						招生數據中心
					</div>
				</div>

				<div class="top-right">
					<nav class="top-nav" ref="topNav">
						<ul class="no-listStyle">
							<li v-for="(i, index) in menus" :key="index" v-if="i.isShow" :id="'m' + i.id">
								<span>
									<a :class="{ on: current(i.outLink, i.children) }" @click="goToPage(i.outLink)">

										<img class="nav-icon1" :src="i.icon" />
										<img class="nav-icon2" :src="i.iconOn" />

										{{ i.name }}</a>
									<!--                  <a
                    :href="
                      i.outLink && i.outLink != '#' ? i.outLink : 'javascript:;'
                    "
                    :target="i.outLink ? '_blank' : ''"
                    v-else
                    >{{ i.name }}</a
                  > -->
								</span>
							</li>
						</ul>

						<div class="header-account" @click="goToPage('/account-info')">
							<div class="account u-flex">
								<img class="avatar" v-if="userInfo.avatar" :src="userInfo.avatar" />
								<img class="avatar" v-else src="../assets/d-logo.png" />
								<div>{{userInfo.schoolName}}，您好
									<i style="margin-left: 0.1rem;" class="el-icon-arrow-down"></i>
								</div>
							</div>
						</div>
					</nav>
					<div class="tools flex__aic">

						<div class="openMenu" ref="openMenu" @click="toggleWapMenu">
							<i></i><i></i><i></i>
						</div>
					</div>
				</div>
			</div>


		</header>
		<userLogin ref="userLogin"></userLogin>
	</div>
</template>
<script>
	import {
		mapMutations
	} from "vuex";
	import userLogin from "@/components/userLogin.vue";
	export default {
		components: {
			userLogin,
		},
		props: {
			variant: {
				type: String,
				default: "default"
			},
			isHide: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				keyword: "",
				searchSelect: 1,
				userInfo: {},
				menus: [{
						id: 'EnrollmentDashboard',
						name: '招生儀表板',
						outLink: '/index',
						isShow: false,
						icon: require('@/assets/t1.png'),
						iconOn: require('@/assets/t2.png'),
					}, {
						id: 'PopularityTrendTracking',
						name: '人氣趨勢追蹤',
						outLink: '/popularity',

						isShow: false,
						icon: require('@/assets/t3.png'),
						iconOn: require('@/assets/t4.png'),
					}, {
						id: 'UserAccountManagement',
						name: '帳號與個人資料',
						isShow: false,
						outLink: '/account',
						children: [{
							outLink: '/account-info',
						}],
						icon: require('@/assets/t5.png'),
						iconOn: require('@/assets/t6.png'),
					},


				],
				logo: "",
				isDark: false,
				lastScrollTop: 0,
				scrollThreshold: 5,
				scrollDirection: "",
				showLoginBox: false,
				searchBox: false,
				userDropShow: false,
				cartNum: 0,
			};
		},
		beforeCreate() {
			// this.$axios
			//   .post("article/category/tree", { parentId: 0, displayType: 1 })
			//   .then((res) => {
			//     this.menus = res.data;
			//   })
			//   .catch((err) => {
			//     console.log(err);
			//   });
			//logo
		},
		methods: {
			...mapMutations(["changeState"]),
			toggleUserDrop() {
				this.userDropShow = !this.userDropShow;
			},
			toggleSearchBox() {
				this.searchBox = !this.searchBox;
			},
			openPopBox(action = "login") {
				this.$refs.userLogin && this.$refs.userLogin.open(action);
			},
			exit() {
				// 清除Token
				localStorage.removeItem("Authorization");
				// 清除存储用户信息
				localStorage.removeItem("member");
				localStorage.removeItem("admin");
				// 修改store
				this.changeState({
					member: {},
					admin: {},
				});
				this.$message.success({
					message: "退出成功！",
					type: "success",
				});
				this.$router.push("/index");
			},
			search() {
				if (!this.keyword.trim()) {
					this.$message({
						message: "请输入关键词",
						type: "warning",
					});
					return;
				}

				// 检查是否已登录
				if (!this.isLoggedIn) {
					this.$message.warning("请先登录后再进行搜索");
					// 打开登录弹窗
					this.openPopBox('login');
					return;
				}

				const searchParams = {
					keyword: this.keyword,
					category: this.searchSelect,
				};

				this.goToPage("/search", searchParams);
			},
			setHeaderStyle(isScroll, isHover) {
				const headerEl = this.$refs.header;
				if (!headerEl) return;
				if (this.isDark) {
					headerEl.classList.remove("light-style");
					headerEl.classList.add("dark-style");
				} else if (isHover || isScroll) {
					headerEl.classList.remove("light-style");
					headerEl.classList.add("dark-style");
				} else {
					headerEl.classList.remove("dark-style");
					headerEl.classList.add("light-style");
				}
			},
			onScroll() {
				const docScroll =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop ||
					0;
				if (Math.abs(docScroll - this.lastScrollTop) > this.scrollThreshold) {
					if (docScroll > this.lastScrollTop) {
						this.scrollDirection = "down";
						this.$refs.header && this.$refs.header.classList.add("up");
					} else {
						this.scrollDirection = "up";
						this.$refs.header && this.$refs.header.classList.remove("up");
					}
					this.lastScrollTop = docScroll;
				}
				this.setHeaderStyle(docScroll > 0, false);
			},
			onMouseEnter() {
				if (this.isDark) return;
				this.setHeaderStyle(false, true);
			},
			onMouseLeave() {
				if (this.isDark) return;
				const docScroll =
					window.pageYOffset ||
					document.documentElement.scrollTop ||
					document.body.scrollTop ||
					0;
				this.setHeaderStyle(docScroll > 0, false);
			},
			toggleWapMenu() {
				const nav = this.$refs.topNav;
				const openMenu = this.$refs.openMenu;
				if (!nav) return;
				nav.classList.toggle("menu-show");
				openMenu.classList.toggle("active");
			},
			closeWapMenu() {
				const nav = this.$refs.topNav;
				const openMenu = this.$refs.openMenu;
				if (!nav) return;
				nav.classList.remove("menu-show");
				openMenu && openMenu.classList.remove("active");
			},
			onDocumentClick(event) {
				const nav = this.$refs.topNav;
				const openMenu = this.$refs.openMenu;
				if (!nav) return;
				const target = event.target;
				// 如果点击发生在 top-nav 或 openMenu 内部，则不处理
				if (
					(nav && nav.contains(target)) ||
					(openMenu && openMenu.contains(target))
				) {
					return;
				}
				// 其它区域点击，移除样式
				this.closeWapMenu();
			},

			getInfo() {
				const that = this;
				that.$axios
					.post("rest-api/member/app/user/getInfo")
					.then((res) => {
						that.userInfo = res.data
						that.menus.some(item => {
							res.data.permissionList.some(item2 => {
								if(item.id==item2){
									item.isShow=true
								}
							})
						})
					})
					.catch((err) => {});
			},
		},
		computed: {
			// 检查是否已登录
			isLoggedIn() {
				return (
					this.$store.state.member?.id && localStorage.getItem("Authorization")
				);
			},
			// 导航当前样式
			current: function() {
				return function(outLink, children) {
					let res = false;
					const that = this;
					const currentUrl = that.$route.path;

					// 检查直接匹配
					if (outLink && currentUrl.indexOf(outLink) >= 0) {
						res = true;
					}
					// 特殊处理：产品详情页应该匹配产品列表菜单
					else if (currentUrl === '/productDetails' && outLink === '/productList') {
						res = true;
					}
					// 检查子菜单
					else {
						if (children && children.length > 0) {
							res = isCurrentUrlInMenu(currentUrl, children);
						}
					}

					function isCurrentUrlInMenu(currentUrl, menuArray) {
						for (const menuItem of menuArray) {
							// 直接匹配
							if (menuItem.outLink && currentUrl.indexOf(menuItem.outLink) >= 0) {
								return true;
							}
							// 特殊处理：产品详情页应该匹配产品列表菜单
							if (currentUrl === '/productDetails' && menuItem.outLink === '/productList') {
								return true;
							}
							// 递归检查子菜单
							if (menuItem.children && menuItem.children.length > 0) {
								const isChildMatch = isCurrentUrlInMenu(
									currentUrl,
									menuItem.children
								);
								if (isChildMatch) {
									return true;
								}
							}
						}
						return false;
					}
					return res;
				};
			},
		},
		watch: {
			$route() {
				this.closeWapMenu();
			},
		},
		mounted() {
			if (localStorage.getItem('userInfo')) {
				this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
			}
			this.getInfo()
			// 初始化样式
			this.setHeaderStyle(false, false);
			// 事件监听
			window.addEventListener("scroll", this.onScroll, {
				passive: true
			});
			if (this.$refs.header) {
				this.$refs.header.addEventListener("mouseenter", this.onMouseEnter);
				this.$refs.header.addEventListener("mouseleave", this.onMouseLeave);
			}
			document.addEventListener("click", this.onDocumentClick, true);
		},
		beforeDestroy() {
			window.removeEventListener("scroll", this.onScroll);
			if (this.$refs.header) {
				this.$refs.header.removeEventListener("mouseenter", this.onMouseEnter);
				this.$refs.header.removeEventListener("mouseleave", this.onMouseLeave);
			}
			document.removeEventListener("click", this.onDocumentClick, true);
		},
	};
</script>
<style lang="scss">
	.input-with-select {
		border-radius: 0.2rem;
		overflow: hidden;
		background-color: rgba(0, 0, 0, 0.1);
		display: flex;

		.el-input-group__prepend {
			background-color: rgba(0, 0, 0, 0.1);
			border: 0;
			border-radius: 0;
			flex-shrink: 0;
			width: 1rem;
			padding: 0;

			.el-select {
				margin: 0;
				display: block;
			}
		}

		.el-input__inner {
			border: 0;
			color: #fff !important;
			font-size: 0.14rem;
			background-color: transparent;
			height: 0.4rem;
			line-height: 0.4rem;
			padding: 0 0.2rem;

			&::placeholder {
				color: rgba(255, 255, 255, 0.4);
			}
		}

		&>.el-input__inner {
			flex: 1;
		}

		.el-select {
			.el-input__inner {
				padding: 0 0.3rem 0 0.2rem;
			}

			.el-input {
				.el-select__caret {
					color: #fff;
					font-size: 0.1rem;
				}
			}
		}

		.el-input__suffix {
			width: 0.16rem;
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}

		.el-input-group__append {
			background: none;
			border: 0;
			border-radius: 0;
			padding: 0;
			display: flex;
			align-items: center;
			width: 0.36rem;
			flex-shrink: 0;

			.el-button {
				background: none;
				padding: 0;
				margin: 0;
				color: #fff;
			}
		}
	}

	@media (min-width: 1025px) {
		.dark-style {
			&:not(.header-member) {
				.input-with-select {
					background-color: #f7f7f7;

					.el-input-group__prepend {
						background-color: #ededed;
					}

					.el-input__inner {
						color: #333 !important;

						&::placeholder {
							color: rgba(153, 153, 153, 0.7);
						}
					}

					.el-select {
						.el-input {
							.el-select__caret {
								color: #999;
							}
						}
					}

					.el-input-group__append {
						.el-button {
							color: #999;
						}
					}
				}
			}
		}
	}

	@media (max-width: 1024px) {
		header {
			&:not(.header-member) {
				.input-with-select {
					background-color: #f7f7f7;

					.el-input-group__prepend {
						background-color: #ededed;
					}

					.el-input__inner {
						color: #333 !important;

						&::placeholder {
							color: rgba(153, 153, 153, 0.7);
						}
					}

					.el-select .el-input .el-select__caret,
					.el-input-group__append .el-button {
						color: #999;
					}
				}
			}
		}
	}
</style>